import { env } from '@shared/config/env';
import { redact } from '@shared/lib';

/**
 * Initialise Sentry with PII scrubbing. No-op when no DSN is configured. Sentry is
 * dynamically imported so it stays OUT of the initial bundle entirely unless enabled
 * (ARCHITECTURE §6, §9).
 */
export async function initSentry(): Promise<void> {
  if (!env.VITE_SENTRY_DSN) return;
  const Sentry = await import('@sentry/react');

  Sentry.init({
    dsn: env.VITE_SENTRY_DSN,
    environment: env.VITE_APP_ENV,
    sendDefaultPii: false,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({ maskAllText: true, blockAllMedia: true }),
    ],
    tracesSampleRate: env.VITE_APP_ENV === 'production' ? 0.1 : 1.0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    beforeSend(event) {
      if (event.request?.data) event.request.data = redact(event.request.data);
      if (event.request) delete event.request.cookies;
      return event;
    },
  });
}
